import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { Stack } from '@common/components/Stack';
import { Routes } from '@common/constants';
import { useTranslations } from '@lang';

import { AccountHeader } from '../components/AccountHeader';
import { AccountLayout } from '../components/AccountLayout';
import { ModifyOrderForm } from '../components/ModifyOrderForm';
import { routeStates } from './CancelOrder';

type AnonymousModifyOrderProps = {
  siteSlug: string;
  orderUuid: string;
  propertyUuid: string;
  propertyId: number;
};

export function AnonymousModifyOrder({
  siteSlug,
  orderUuid,
  propertyUuid,
  propertyId,
}: AnonymousModifyOrderProps) {
  const router = useRouter();
  const { t } = useTranslations();
  const isSuccess =
    router.query.state === routeStates.SUCCESS || router.query.state === routeStates.CANCELLED;
  if (isSuccess) {
    return (
      <>
        <AccountLayout>
          <AccountHeader>{t('orderRequest.heading')}</AccountHeader>

          <p>{t(routeStates.SUCCESS ? 'orderRequest.message' : 'orderRequest.cancelledMessage')}</p>
          <p>
            <Link href={Routes.HOME}>
              <a className="underline">{t('orderRequest.callToAction')}</a>
            </Link>
          </p>
        </AccountLayout>
      </>
    );
  }

  return (
    <>
      <AccountLayout>
        <Stack>
          <ModifyOrderForm
            data-testid="anon-modify-order-form"
            siteSlug={siteSlug}
            orderUuid={orderUuid}
            siteUuid={propertyUuid}
            propertyId={propertyId}
          />
        </Stack>
      </AccountLayout>
    </>
  );
}
